var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "old-browser" }, [
    _c("header", [
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closeMenu,
              expression: "closeMenu"
            }
          ],
          staticClass: "container"
        },
        [_vm._m(0)]
      )
    ]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("footer", [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-5" }, [
            _c("div", { staticClass: "foot-nav" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-5" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-7" }, [
                  _c(
                    "p",
                    { staticClass: "Raleway min p-white swed-links" },
                    [
                      _c("img", {
                        attrs: { src: "/img/icon/sweden.svg", alt: "" }
                      }),
                      _vm._v(" "),
                      _c("router-link", { attrs: { to: { name: "index" } } }, [
                        _vm._v(
                          "\n                                        Show site in Swedish\n                                    "
                        )
                      ])
                    ],
                    1
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-1" }),
          _vm._v(" "),
          _vm._m(3)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-between" }, [
      _c("div", { staticClass: "col-md-2 col-8" }, [
        _c("div", { staticClass: "logo" }, [
          _c("img", { attrs: { src: "/img/header/logo.svg", alt: "" } })
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-lg-9 align-items-center d-none d-lg-flex justify-content-center"
        },
        [
          _c("div", { staticClass: "head__items" }, [
            _c("div", { staticClass: "head-item" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", { attrs: { src: "/img/header/shield.svg", alt: "" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("p", { staticClass: "min-min p-dgrey" }, [
                  _vm._v("Elbyte med prisgaranti")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "head-item" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", { attrs: { src: "/img/header/scales.svg", alt: "" } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("p", { staticClass: "min-min p-dgrey" }, [
                  _vm._v("Jämför och byt gratis ")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "head-item" }, [
              _c("div", { staticClass: "img" }, [
                _c("img", {
                  attrs: { src: "/img/header/calendar.svg", alt: "" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("p", { staticClass: "min-min p-dgrey" }, [
                  _vm._v("14 dagars ångerrätt")
                ])
              ])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "main",
        staticStyle: {
          margin: "50px auto 50px auto",
          "text-align": "center",
          "max-width": "500px"
        }
      },
      [
        _c("div", { staticStyle: {} }, [
          _c("h1", [
            _vm._v(
              "You are using an Outdated Browser. For a use this website, please upgrade your web browser "
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("div", { staticClass: "foot-logo" }, [
        _c("img", { attrs: { src: "/img/logo-footer.svg", alt: "" } })
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "Raleway min p-white" }, [
        _vm._v("Made with "),
        _c("img", { attrs: { src: "/img/icon/like.svg", alt: "" } }),
        _vm._v(" in Sweden")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-2" }, [
      _c("p", { staticClass: "min-min foot-info p-white" }, [
        _vm._v("Allmän information")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "min foot-info p-white" }, [
        _vm._v("TecknaEl.se ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "min foot-info p-white" }, [
        _vm._v("Orgno: 444344-1235")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }